import React from 'react'
import { Icon, Stack, Text } from '@ui'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

import { useGetSimpleAccountAddress, useOpForSimpleAccount } from './hooks'

export function DetectUndeployedSimpleAccount() {
    const { data: simpleAccount, isLoading: isLoadingSimpleAccount } = useGetSimpleAccountAddress()
    const { data: primaryAAAddress, isLoading: isLoadingPrimaryAAAddress } =
        useMyAbstractAccountAddress()
    const isSameAddress = simpleAccount?.address.toLowerCase() === primaryAAAddress?.toLowerCase()

    const { balance, balanceIsLessThanCost, isLoadingBalance } = useOpForSimpleAccount(
        simpleAccount?.address,
    )
    const { openPanel } = usePanelActions()

    const onClick = () => {
        openPanel('non-deployed-simple-transfer')
    }

    if (
        !simpleAccount ||
        isSameAddress ||
        isLoadingSimpleAccount ||
        isLoadingPrimaryAAAddress ||
        isLoadingBalance
    ) {
        return null
    }
    if (balance && balance.value === 0n) {
        return null
    }

    if (balanceIsLessThanCost) {
        return null
    }

    return (
        <Stack
            horizontal
            hoverable
            gap
            padding
            cursor="pointer"
            background="level2"
            border="level3"
            rounded="md"
            alignItems="center"
            justifyContent="spaceBetween"
            onClick={onClick}
        >
            <Stack horizontal gap alignItems="center">
                <Icon type="alert" color="negative" />
                <Text>{`We've detected orphaned funds. Click here to recover them.`}</Text>
            </Stack>
            <Icon type="linkOut" color="default" size="square_md" />
        </Stack>
    )
}
